import {
    FEEDBACK_DIALOG_UPDATE_TITLE,
    FEEDBACK_DIALOG_UPDATE_DISPLAY_DIALOG,
    FEEDBACK_DIALOG_UPDATE_CONTENT,
    FEEDBACK_DIALOG_UPDATE_ERROR,
    FEEDBACK_DIALOG_RESET,
} from '../actions/types'

/**
 * title : main title of dialog
 * subtitle : title under main title
 * text: small text under subtitle
 * files: array of files - if not empty will display files in dialog
 * progress: progress bar
 * displayDialog: show dialog or not
 * hasErrors: display red dialog
 */
interface FeedbackDialogStore {
    title: string
    subtitle: string
    text: string
    files: Array<any>
    progress: number
    displayDialog: boolean
    hasErrors: boolean
}

const INITIAL_STATE: FeedbackDialogStore = {
    title: '',
    subtitle: '',
    text: '',
    files: [],
    progress: 0,
    displayDialog: false,
    hasErrors: false,
}

export default (state = INITIAL_STATE, action: any): FeedbackDialogStore => {
    switch (action.type) {
        case FEEDBACK_DIALOG_UPDATE_TITLE:
            return {
                ...state,
                title: action.payload.title,
            }
        case FEEDBACK_DIALOG_UPDATE_CONTENT:
            return {
                ...state,
                subtitle: action.payload.subtitle || '',
                text: action.payload.text || '',
                files: action.payload.files || [],
                progress: action.payload.progress || 0,
            }
        case FEEDBACK_DIALOG_UPDATE_DISPLAY_DIALOG:
            return {
                ...state,
                displayDialog: action.payload.displayDialog,
            }
        case FEEDBACK_DIALOG_UPDATE_ERROR:
            return {
                ...state,
                hasErrors: action.payload.hasErrors,
            }
        case FEEDBACK_DIALOG_RESET: {
            return INITIAL_STATE
        }
        default:
            return state
    }
}
